export default __webpack_public_path__ + "static/media/thumb-bad.8f40bb05.svg";